import { render, staticRenderFns } from "./CreateSynonymPopover.vue?vue&type=template&id=09bd463d&"
import script from "./CreateSynonymPopover.vue?vue&type=script&lang=js&"
export * from "./CreateSynonymPopover.vue?vue&type=script&lang=js&"
import style0 from "./CreateSynonymPopover.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports